/**
 * @fileoverview added by tsickle
 * Generated from: models/key.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/** @enum {string} */
var KeyLocation = {
    Destroyed: "destroyed",
    Office: "office",
    OfficeHolidayBag: "holibag",
    Unknown: "unknown",
    WithCustomer: "customer",
    WithWorker: "worker",
};
export { KeyLocation };
/**
 * @record
 */
function BaseKey() { }
if (false) {
    /** @type {?} */
    BaseKey.prototype.code;
    /** @type {?} */
    BaseKey.prototype.holderId;
    /** @type {?} */
    BaseKey.prototype.location;
    /** @type {?} */
    BaseKey.prototype.propertyId;
}
/**
 * @record
 */
function KeyExpandables() { }
if (false) {
    /** @type {?|undefined} */
    KeyExpandables.prototype.holder;
    /** @type {?|undefined} */
    KeyExpandables.prototype.transferInProgress;
    /** @type {?|undefined} */
    KeyExpandables.prototype.remoteKeyTransferInProgress;
}
/**
 * @record
 */
function KeyModelMixin() { }
if (false) {
    /** @type {?} */
    KeyModelMixin.prototype.isInOffice;
    /** @type {?} */
    KeyModelMixin.prototype.isWithWorker;
}
/**
 * Model representing a key.
 * @record
 */
export function Key() { }
/** @type {?} */
export var key = model.extend((/** @type {?} */ ({
    modelName: 'key'
})));
// Implements helper properties
defineModelProperties(key, {
    isInOffice: {
        get: /**
         * @return {?}
         */
        function () {
            return [KeyLocation.Office, KeyLocation.OfficeHolidayBag].includes(this.location);
        }
    },
    isWithWorker: {
        get: /**
         * @return {?}
         */
        function () {
            return this.location === KeyLocation.WithWorker;
        }
    }
});
/** @enum {string} */
var KeyCollectionStateValue = {
    None: "none",
    Done: "done",
    Pending: "pending",
};
export { KeyCollectionStateValue };
/**
 * Model representing a key collection state for a property.
 * @record
 */
export function KeyCollectionState() { }
if (false) {
    /** @type {?} */
    KeyCollectionState.prototype.state;
    /** @type {?} */
    KeyCollectionState.prototype.visit;
}
/** @type {?} */
export var keyCollectionState = model.extend((/** @type {?} */ ({
    modelName: 'keyCollectionState'
})));
/**
 * Model representing a key transfer.
 * @record
 */
export function KeyTransfer() { }
if (false) {
    /** @type {?|undefined} */
    KeyTransfer.prototype.holder;
    /** @type {?} */
    KeyTransfer.prototype.key;
    /** @type {?} */
    KeyTransfer.prototype.fromLocation;
    /** @type {?} */
    KeyTransfer.prototype.toLocation;
}
/** @type {?} */
export var keyTransfer = model.extend((/** @type {?} */ ({
    modelName: 'keyTransfer'
})));
